import { render, staticRenderFns } from "./LogoCarousel.vue?vue&type=template&id=3bbd8052&scoped=true&"
import script from "./LogoCarousel.vue?vue&type=script&lang=js&"
export * from "./LogoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LogoCarousel.vue?vue&type=style&index=0&id=3bbd8052&lang=scss&scoped=true&"
import style1 from "./LogoCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd8052",
  null
  
)

export default component.exports